<template>
  <div :key="$route.path">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-sm-flex align-items-center justify-content-between"
        >
          <div class="page-title-right">
            <h4 class="mb-sm-0 font-size-18">
              All Modules of Course - {{ $route.params.title }}
            </h4>
            <a
              @click="$router.go(-1)"
              class="btn btn-primary w-md mybutton myleft"
            >
              <box-icon
                name="chevrons-left"
                type="solid"
                color="#ffffff"
                class="myicon"
              ></box-icon
              >Back</a
            >
          </div>

          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <!-- <a href="">Services</a> -->
                <router-link to="/home/all_courses" class="waves-effect">
                  All Courses List
                </router-link>
              </li>
              <li class="breadcrumb-item active">All Modules List</li>
            </ol>
            <div>
              <button
                class="btn btn-primary waves-effect btn-label waves-light mybutton"
                @click="showModal($route.params.id)"
              >
                Add Module
              </button>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-lg-12">
        <div class="">
          <div class="table-responsive">
            <div class="card">
              <div class="card-body">
                <table
                  class="table table-hover table-bordered"
                  id="audios_table"
                >
                  <thead>
                    <tr class="frown">
                      <th scope="col" style="width: 5%">#</th>
                      <th scope="col" style="width: 10%">Image</th>
                      <th scope="col" style="width: 20%">Audio's Name</th>
                      <th scope="col" style="width: 50%">Description</th>
                      <th scope="col" style="width: 50%">Status</th>
                     
                      <th scope="col" style="width: 5%">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in all_lessons" :key="index">
                      <td scope="row" class="sorting_1">{{ index + 1 }}</td>
                      <td>
                        <img :src="item.image" alt="" />
                      </td>
                      <td>
                        <h5>
                          {{ item.title }}
                        </h5>
                        <!-- <p class="text-muted mb-0 text-ellipse-250">
                          {{ item.name }}
                        </p> -->
                      </td>

                      <td>
                        <p>
                          {{ item.description }}
                        </p>
                        <!-- <p class="text-muted mb-0 text-ellipse-250">
                          {{ item.name }}
                        </p> -->
                      </td>

                      <td>
                        <toggle-button @change="changeStatus(item)" :value="(item.status == 'Active') ? true : false" />
                      </td>

                     

                      <td>
                        <!-- <div class="w3-dropdown-click mydropdown"> -->
                        <div class="dropdown">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle card-drop"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <box-icon
                              name="dots-horizontal-rounded"
                              class="myddicon"
                            ></box-icon>
                          </a>
                          <!-- <button @click="myFunction()" class="w3-button"> -->
                          <!-- <box-icon
                              name="dots-horizontal-rounded"
                              class="myddicon"
                            ></box-icon> -->
                          <!-- </button> -->
                          <!-- <div
                            id="Demo"
                            class="w3-dropdown-content w3-bar-block w3-card-4 w3-animate-zoom"
                          > -->
                          <!-- <div
                            id="myDIV"
                            class="dropdown-content w3-animate-zoom"
                          > -->
                          <div
                            class="dropdown-menu dropdown-menu-end dropdown-content w3-animate-zoom"
                            id="myDIV"
                          >
                            <!-- <div
                              class="dropdown-menu dropdown-menu-end dropdown-content"
                            > -->
                            <div>
                              <!-- <router-link
                                :to="'content/' + item.id"
                                class="listbox w3-bar-item w3-button"
                               
                              >
                                <box-icon
                                  name="library"
                                  class="myicon"
                                ></box-icon>
                                Module Contents</router-link
                              > -->

                              <!-- <router-link
                                :to="'/home/content/'+item.id"
                                class="listbox w3-bar-item w3-button"
                              >
                                <box-icon
                                  name="library"
                                  class="myicon"
                                ></box-icon>
                                Module Contents</router-link
                              > -->
                              
                              <div class="menu-item">
                  <a
                     href="javascript:;"
                    @click="navigate_content(item.id, item.title)"
                     class="listbox w3-bar-item w3-button"
                  >
                    <!-- <router-link
                    :to="'/home/hypnosis/' + item.id"
                    class="menu-link"
                  > -->
                   
                       
                  
                    <!-- <span class="menu-title">{{ item.title }}</span> -->
                   <box-icon type='solid' name='book-content' class="myicon"></box-icon>
                    Lessons
                  </a>
                  <!-- </router-link> -->
                  </div>
                              <a
                                href="javascript:;"
                                @click="
                                  showModal03(
                                    item.id,
                                    item.title,
                                    item.description,
                                    item.course_id,
                                    item.image,
                                  )
                                "
                                class="listbox w3-bar-item w3-button"
                              >
                                <box-icon name="edit" class="myicon"></box-icon>
                                Update</a
                              >
                              <a
                                href="javascript:;"
                                @click="remove_lesson(item.id)"
                                class="listbox w3-bar-item w3-button"
                                ><box-icon
                                  type="solid"
                                  name="message-alt-x"
                                  class="myicon"
                                ></box-icon
                                >Delete</a
                              >
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import ModalEditLesson from "../Modals/ModalEditLesson.vue";
import ModalAddLesson from "../Modals/ModalAddLesson.vue";
import api from "../../config/api.js";
import $ from "jquery";
//import { VsaList, VsaItem, VsaHeading, VsaContent } from "vue-simple-accordion";
//import "vue-simple-accordion/dist/vue-simple-accordion.css";
//import Accordions from "../../components/Accordions.vue";
export default {
  name: "Courses",
  components: {
    // VsaList,
    // VsaItem,
    // VsaHeading,
    // VsaContent,
    //VsaIcon
    //Accordions,
  },
  data() {
    return {
      is_active: true,
      all_lessons: [],
      course_id: "",
      catname: "",
    };
  },

  created() {
    this.$root.$refs.Courses = this;

    this.course_id = this.$route.params.id;
    console.log(this.$route.params, "Alicreated");

    this.$watch(
      () => this.$route.params,
      () => {
        this.course_id = this.$route.params.id;
        //this.$router.go();
        this.alllessons();
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
  },
  mounted() {
    //this.allaudios();
    this.course_id = this.$route.params.id;
    this.alllessons();
  },

  methods: {

    async changeStatus(item){
      item.status = !item.status
      try {
        let result = await api.post(`/admin/lesson-status?id=${item.id}`);
        this.$toast.success(result.data.message);
      } catch (error) {
        this.error = error.response.data.message;
        this.$toast.error(this.error);
      }
    },

    


    async alllessons() {
      try {
        let result = await api.get(`/admin/course-lessons`, {
          params: { course_id: this.course_id },
        });

        setTimeout(() => {
          $("#audios_table").DataTable();
        }, 0);

        this.all_lessons = result.data.lessons;

        //console.log(result);
      } catch (error) {
        this.error = error.response.data.message;
        this.$toast.error(this.error);
      }
    },

    async remove_lesson(id) {
      try {
        this.$swal({
          title: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No, cancel!",
          confirmButtonClass: "btn btn-success",
          cancelButtonClass: "btn btn-danger",
          buttonsStyling: true,
        }).then(async (res) => {
          if (res.isConfirmed) {
            let result = await api.delete(`/admin/delete-Module/` + id);
            this.alllessons();
            this.$toast.success(result.data.message);
            // console.log("I am in Delete mode", result);
            //this.onLoad();
          }
        });
      } catch (error) {
        this.$toast.error(error.response.data.message);
      }
    },

    showModal(courseid) {
      this.$modal.show(
        ModalAddLesson,
        { courseid: courseid },
        { draggable: true },
        {
          "before-close": () => {
            this.onLoad();
          },
        }
      );
    },

    showModal03(aid, aname, adesc, courseid,image) {
      this.$modal.show(
        ModalEditLesson,
        {
          aid: aid,
          aname: aname,
          adesc: adesc,
          courseid: courseid,
          image
        },
        { draggable: true },
        {
          "before-close": () => {
            //this.allAudios(libid);
          },
        }
      );
    },
    navigate_content(id,title){
      // console.log('courses');
      // this.$store.dispatch('getLessonContentData',id)
      // console.log(this.$store.state.lesson_content_data);
      // console.log(id);
        this.$router.push({
        name: "content",
        params: { id: id, title },
      });
    },

    callme() {
      this.alllessons();
    },
    sayname(name) {
      this.catname = name;
    },
  },
};
</script>

<style scoped>
#audios_table h5 {
  /* line-height: 65px; */
  margin-top: 15px;
}
#audios_table .switch {
  margin-top: 25px;
}
#audios_table .dropdown {
  margin-top: 15px;
}
</style>
